import axios from "axios";
import FormData from "form-data";

const isDevMode = process.env.NODE_ENV === "development";
export const apiEndpoint = `${
  isDevMode ? "https://sgbc.constructdigital.net" : window.location.origin
}/wp-json/greenest-town/`;

export const fetchHouseImages = async () => {
  var config = {
    method: "get",
    url: apiEndpoint + "v1/houses/images",
    headers: {},
  };

  try {
    const response = await axios(config);

    if (response.data && response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const fetchCategories = async () => {
  var config = {
    method: "get",
    url: apiEndpoint + "v1/main-categories",
    headers: {},
  };

  const response = await axios(config);

  if (response.data && response.status === 200) {
    return response.data;
  }
};

export const fetchTownList = async () => {
  const config = {
    method: "get",
    url: apiEndpoint + "v1/towns",
  };

  try {
    const response = await axios(config);

    if (response.data && response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const fetchHouses = async () => {
  const config = {
    method: "get",
    url: apiEndpoint + "v1/houses",
  };

  try {
    const response = await axios(config);

    if (response.data && response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const uploadTownImages = async (data) => {
  var config = {
    method: "post",
    url: apiEndpoint + "v1/houses",
    data: data,
  };

  try {
    const response = await axios(config);

    if (response.data && response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const fetchCategoryImages = async (cateID) => {
  const config = {
    method: "get",
    url: `${apiEndpoint}v1/houses/images?main_category_id=${cateID}`,
  };

  try {
    const response = await axios(config);

    if (response.data && response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const doHouseVote = async (imageID) => {
  let data = new FormData();
  data.append("id", imageID);

  var config = {
    method: "post",
    url: apiEndpoint + "v1/houses/images/vote",
    data: data,
  };

  try {
    const response = await axios(config);

    if (response.data && response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const fetchTownImages = async (townID) => {
  var config = {
    method: "get",
    url: `${apiEndpoint}v1/houses/images?town_id=${townID}`,
  };

  try {
    const response = await axios(config);

    if (response.data && response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

// export const fetchImageById = async (imgID) => {
//   var config = {
//     method: "get",
//     url: `http://sgbc.constructdigital.net/wp-json/greenest-town/v1/houses/images?id=${imgID}`,
//   };

//   try {
//     const response = await axios(config);

//     if (response.data && response.status === 200) {
//       return response.data;
//     }
//   } catch (error) {
//     console.log(error);
//   }
// };
